/*
 Created by CHT 2020/1/18 17:32
 */
export const phoneReg = /^1[34578]\d{9}$/			// 电话号码
export const numberReg = /^\d+\.?\d{0,2}$/			//
export const phones = {
  '+86': {
    content: '中国大陆+86',
    lable: '+86',
    pattern: /^(\+?0?86\-?)?1[345789]\d{9}$/
  }
}
// 匹配数字 大小字母 汉字之外的所有字符
export const char = /[^\dA-Za-z\u3007\u4E00-\u9FCB\uE815-\uE864]/gi
